import { UrlHelper } from "@/utilities/UrlHelper";
import * as Cookie from "js-cookie";
export class GoogleAnalytics {
    public static UAKey = "UA-2423271-23";
    public static SetContext() {
        const lang = Cookie.get("lang");
        gtag("config", GoogleAnalytics.UAKey,
        {
            anonymize_ip: true,
            page_path: window.location.pathname.replace(/\/$/, ""),
            page_location: window.location.origin + window.location.pathname,
            page_title: window.document.title,
            dimension1: AuthFlowContext.popup,
            dimension2: AuthFlowContext.flow,
            dimension3: AuthFlowContext.autoAuthCode ? true : false,
            dimension4: AuthFlowContext.isApp ? `app` : undefined,
            dimension5: AuthFlowContext.memberType,
            dimension6: AuthFlowContext.clientId,
            dimension7: AuthFlowContext.referringSource || undefined,
            dimension8: lang || "sv",
            linker: {
              domains: ["connect.mecenat.com", "mecenat.com", "mecenatalumni.com"],
            },
        });
    }
    public static TrackCurrentPageView(pageName: string, pagePath: string) {
      gtag("config", GoogleAnalytics.UAKey,
      {
          page_path: pagePath.replace(/\/$/, ""),
          page_location: window.location.origin + pagePath.replace(/\/$/, ""),
          page_title: pageName,
      });
    }
    private static getUnpersonifiedPageUrl(includeUrlHost: boolean) {
        let url;
        if (includeUrlHost) {
          url = window.location.href.toLowerCase();
        } else {
          url =
            window.location.pathname.toLowerCase() +
            window.location.search.toLowerCase();
        }
        url = UrlHelper.removeParamFromUrl("uid", url); // Remove Uid parameter
        url = UrlHelper.removeParamFromUrl("mecenat_id", url); // Remove discountcode parameter
        url = UrlHelper.removeParamFromUrl("auto", url);
        url = UrlHelper.removeParamFromUrl("id", url);
        return url;
      }
}
